
import { Component, Vue } from 'vue-property-decorator'
import authModule from '@/store/auth'
import dealModule from '@/store/deal'
import { DealComment } from '@/types/Deal'
import { DealStatus } from '@/utils/enums'

@Component({
  name: 'DealCommentsDialog',
  components: {}
})
class DealCommentsDialog extends Vue {
  private visible = true
  private loading = false
  private currentComment = ''

  private get comments(): DealComment[] {
    return dealModule.comments
  }

  private async addComment() {
    if (this.currentComment.trim().length === 0) {
      return
    }

    this.loading = true

    await dealModule.addComment(this.currentComment)

    this.loading = false
    this.currentComment = ''
  }

  private async created() {
    Vue.filter('formattedDate', this.formattedDate)

    await dealModule.fetch(dealModule.deal!._id)
  }

  private formattedDate(rawDate: string) {
    const date = new Date(rawDate)

    const time = date.toLocaleTimeString('de-DE', {
      hour: '2-digit',
      minute: '2-digit'
    })

    return `${date.toLocaleDateString('de-DE')} um ${time}`
  }
}

export default DealCommentsDialog
